import { FormConfigContext } from '@juvare/common-form-ui/FormConfigContext';
import { Box, Button } from '@mui/material';
import React from 'react';
import { useCommonDataTableUiTranslation } from '../hooks';
import { AllFiltersSlideout, ChipsBar } from './components';
import { useFiltersBarState, usePromiseResult } from './hooks';
import { isEmptyFilter } from './utils';
/**
 * Component that renders a filter.
 * Has 3 parts:
 * - quick filter
 * - all filters form that opens in a slideout
 * - chips
 */
export function FiltersBar({ config, initialFilterData, onFilter, onFilterDebounceDelay, formParams, valueProviders, subFormProviders, rules, widgets, globalWidgetConfig, saveFilterLabel, saveFilterDisabled, onSaveFilter, }) {
    var _a;
    const { t } = useCommonDataTableUiTranslation();
    const formConfigContext = React.useContext(FormConfigContext);
    const { appliedFilterData, onChangeFilterData, onClearFilters } = useFiltersBarState(initialFilterData !== null && initialFilterData !== void 0 ? initialFilterData : emptyInitialFilterData, onFilter, onFilterDebounceDelay !== null && onFilterDebounceDelay !== void 0 ? onFilterDebounceDelay : 100);
    const [allFiltersOpen, setAllFiltersOpen] = React.useState(false);
    const filterChipsResult = usePromiseResult(config.getFilterChips, appliedFilterData, valueProviders, formConfigContext);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: { display: 'flex', flexDirection: 'column' } },
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: {
                        xs: 'column',
                        sm: 'row',
                    },
                    alignItems: {
                        xs: 'stretch',
                        sm: 'center',
                    },
                    justifyContent: '',
                    gap: 2,
                } },
                config.quickFilters &&
                    config.quickFilters.length > 0 &&
                    ((_a = config.quickFilters) === null || _a === void 0 ? void 0 : _a.map((quickFilter, index) => (React.createElement(React.Fragment, { key: index }, quickFilter.render({
                        filterData: appliedFilterData,
                        valueProviders: valueProviders,
                        onChangeFilterData,
                        filterDependencies: config.filterDependencies,
                    }))))),
                config.allFilters && (React.createElement(Button, { sx: { whiteSpace: 'nowrap' }, onClick: () => setAllFiltersOpen(true) }, t('allFilters', { count: filterChipsResult.result ? filterChipsResult.result.length : 0 })))),
            config.getFilterChips && (React.createElement(ChipsBar, { filtered: !isEmptyFilter(appliedFilterData), filterChipsResult: filterChipsResult, onChangeFilterData: onChangeFilterData, onClearFilters: onClearFilters, saveFilterLabel: saveFilterLabel, saveFilterDisabled: saveFilterDisabled, onSaveFilter: onSaveFilter }))),
        config.allFilters && (React.createElement(AllFiltersSlideout, { open: allFiltersOpen, allFilters: config.allFilters, appliedFilterData: appliedFilterData, onChangeFilterData: (action) => {
                onChangeFilterData(action);
                setAllFiltersOpen(false);
            }, onClearFilters: onClearFilters, onCancel: () => {
                setAllFiltersOpen(false);
            }, formParams: formParams, valueProviders: valueProviders, subFormProviders: subFormProviders, rules: rules, widgets: widgets, globalWidgetConfig: globalWidgetConfig }))));
}
const emptyInitialFilterData = {};
